import React from 'react';
export function Summary({
  cart,
  pricingData,
  priceType,
  total,
  onClearCart
}) {
  return <div className="mb-8 border-t border-b py-6" data-id="element-212" data-mp="37yritnx2wg8b">
      <div className="flex justify-between items-center mb-4" data-id="element-213" data-mp="3802kni6yrdws">
        <h2 className="text-2xl font-bold text-blue-900" data-id="element-214" data-mp="33wwfkdvl7srw">Quote Summary</h2>
        <button className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700" onClick={onClearCart} data-id="element-215" data-mp="2yyuytzlmw5jl">
          START OVER
        </button>
      </div>
      <div className="overflow-x-auto" data-id="element-216" data-mp="2p8rz7gk0btca">
        <table className="min-w-full bg-white border" data-id="element-217" data-mp="2p7qjgys1qio8">
          <thead data-id="element-218" data-mp="2k9orfocn790m">
            <tr className="bg-gray-100" data-id="element-219" data-mp="2k96x4x9jj4vc">
              <th className="py-2 px-4 border text-left" data-id="element-220" data-mp="2ka87t0mn9pcj">Item</th>
              <th className="py-2 px-4 border text-right" data-id="element-221" data-mp="2g8whesvy503a">Price</th>
              <th className="py-2 px-4 border text-center" data-id="element-222" data-mp="2b90nxnkvkr1z">Quantity</th>
              <th className="py-2 px-4 border text-right" data-id="element-223" data-mp="2b88qs8bmql9l">Subtotal</th>
            </tr>
          </thead>
          <tbody data-id="element-224" data-mp="26c0i9drxtqbe">
            {Object.entries(cart).map(([itemId, quantity]) => {
            const item = pricingData.find(p => p.id === itemId);
            if (!item) return null;
            const price = item[priceType];
            const subtotal = price * quantity;
            return <tr key={itemId} data-id="element-225" data-mp="2wjay0ixxkruw">
                  <td className="py-2 px-4 border" data-id="element-226" data-mp="31jyxzu450j19">
                    <div className="font-medium" data-id="element-227" data-mp="31kqjud7xn2ec">{item.name}</div>
                    {item.description && <div className="text-sm text-gray-600" data-id="element-228" data-mp="3p88d6d6ui8jf">
                        {item.description}
                      </div>}
                  </td>
                  <td className="py-2 px-4 border text-right" data-id="element-229" data-mp="3fbddvs2r0443">
                    ${price.toFixed(2)}
                  </td>
                  <td className="py-2 px-4 border text-center" data-id="element-230" data-mp="3kct37wbykwsa">{quantity}</td>
                  <td className="py-2 px-4 border text-right" data-id="element-231" data-mp="23vezr9spqrw0">
                    ${subtotal.toFixed(2)}
                  </td>
                </tr>;
          })}
          </tbody>
          <tfoot data-id="element-232" data-mp="1ot6sdnii3qoj">
            <tr className="bg-gray-100" data-id="element-233" data-mp="1ovt5e2o5uye5">
              <td colSpan={3} className="py-2 px-4 border text-right font-bold" data-id="element-234" data-mp="1krv1zfrsz1fa">
                Total:
              </td>
              <td className="py-2 px-4 border text-right font-bold" data-id="element-235" data-mp="1g03krvuje81t">
                ${total}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>;
}